import React, { useEffect, useState } from "react";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
const Carousel = () => {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    useEffect(() => {
        document.getElementById("vid").play();
    }, []);
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <div class="corpix-hero-section d-flex section">
            <div
                class="video-container"
                style={{ zIndex: "-1", width: "100%" }}
            >
                <div id="overlay"></div>
                <video loop autoplay muted id="vid" style={{ height: "132%" }}>
                    <source
                        src={require("../../Assets/goldbarvideos.mp4")}
                        type="video/mp4"
                    />
                </video>
                <div
                    class="hero-content"
                    style={{
                        position: "absolute",
                        zIndex: 1,
                        top: "38px",
                        left: 0,
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <h3
                        class="sub-title"
                        data-aos-delay="2000"
                        data-aos="fade-down"
                        style={{ fontSize: "40px" }}
                    >
                        {lang === "Fr" ? `BIENVENUE SUR` : `Welcome To`}
                    </h3>
                    <h2
                        class="title"
                        data-aos="fade-down"
                        data-aos-delay="2200"
                    >
                        Gold Bar International Ltd
                    </h2>
                    <div
                        class="hero-btn"
                        data-aos="fade-down"
                        data-aos-delay="2400"
                    >
                        <Link class="btn" to="/products-services">
                            {lang === "Fr" ? `NOS SERVICES` : ` OUR SERVICES`}{" "}
                            <span class="btn-icon">
                                <img src="Files/images/btn-icon.png" alt="" />
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Carousel;
